<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid lk-eu-mobile-form-fields">
      <div class="field">
        <label class="font-medium required-field">Описание</label>
        <crm-editor
          [(value)]="task.description"
          [disabled]="isCoreFieldsLocked"
          height="250px"></crm-editor>
        <small
          *ngIf="errors?.description"
          class="p-error">
          {{ errors.description | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Тип заявки</label>
        <crm-hd-task-type-single-select
          [customRequest]="true"
          [taskTypes]="taskTypes"
          [(selectedTaskType)]="task.taskType"
          (selectedTaskTypeChange)="onTaskTypeChange($event)"
          [showClear]="canClearTaskType"
          [isError]="$any(errors?.taskType)"
          [disabled]="isCoreFieldsLocked"
          appendTo="body">
        </crm-hd-task-type-single-select>
        <small
          *ngIf="errors?.taskType"
          class="p-error">
          {{ errors.taskType | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Аудиторы</label>
        <crm-personal-account-external-user-multi-select
          [(selectedExternalUsers)]="task.externalUserAuditors"
          [isError]="$any(errors?.externalUserAuditors)"
          appendTo="body"></crm-personal-account-external-user-multi-select>
      </div>

      <div
        *ngIf="lkEavAttributes.length && task.eavEntity"
        class="field mt-3">
        <div class="frm-color-blue uppercase font-bold mb-3">Дополнительные реквизиты</div>
        <crm-hd-eav-fields
          mode="form"
          [attributes]="lkEavAttributes"
          [values]="task.eavEntity.values"
          [errors]="errors"
          [excludedAttributeTypes]="eavExcludedInPa"
          [hdTaskStatusId]="hdTaskStatusId"
          [canEdit]="!isCoreFieldsLocked"
          [showRequiredMarker]="true"></crm-hd-eav-fields>
      </div>

      <div
        *ngIf="!(form$ | async)?.isEdit"
        class="field">
        <label class="font-medium">Файлы</label>
        <div
          *ngIf="task.files?.length"
          class="mb-2">
          <crm-files-list
            [files]="$any(task.files)"
            [canDelete]="true"
            (deleteFile)="deleteFile(task.files, $event)"></crm-files-list>
        </div>
        <p-fileUpload
          #fileUpload
          mode="basic"
          [customUpload]="true"
          chooseIcon="pi-paperclip"
          chooseLabel="Прикрепить файл"
          [disabled]="filesLoading"
          (uploadHandler)="uploadFiles($event)"
          [auto]="true">
        </p-fileUpload>
        <small
          *ngIf="errors?.files"
          class="p-error">
          {{ errors.files | join }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveTask()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
